import Link from "@/components/Link";
import type { SectionPackage } from "@/lib/navigation";
import { AppRoutes } from "@/lib/routeResolver";
import styles from "./package-card.module.css";

export default function SectionPackageCard({
  pack,
}: {
  pack: SectionPackage;
}) {
  const href = AppRoutes.package(pack.pageURL);

  return (
    <div className="tour-box th-ani gsap-cursor h-100">
      <div className="tour-box_img global-img">
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img
          src={pack.image || "/main/img/bg/italy-package-bg.jpg"}
          alt={pack.name}
          style={{ height: "250px", objectFit: "cover" }}
        />
      </div>
      <div className="tour-content">
        <h3 className="box-title">
          <Link href={href} title={pack.name}>{pack.name}</Link>
        </h3>
        {pack.countriesNames.length > 0 && (
          <div className="tagcloud mt-2 mb-1">
            {pack.countriesNames.map((country) => (
              <Link key={country} href={href} title={pack.name}>
                {country}
              </Link>
            ))}
          </div>
        )}
        <h4 className="tour-box_price">
          From
          <span className="currency ms-1">
            ${Number(pack.startingFrom).toLocaleString()}
          </span>
        </h4>
        <div className={`tour-action ${styles.actions}`}>
          <span className={styles.duration}>
            <i className="fa-light fa-clock"></i>
            {pack.days} Days
          </span>
          <Link
            href={href}
            className="th-btn style1 th-icon"
            title={`More Details about ${pack.name}`}
          >
            More Details
            <span className="visually-hidden">{` about ${pack.name}`}</span>
          </Link>
        </div>
      </div>
    </div>
  );
}
